import { render, staticRenderFns } from "./TeamFileReviewsByDay.vue?vue&type=template&id=2e0789d8&scoped=true&"
import script from "./TeamFileReviewsByDay.vue?vue&type=script&lang=js&"
export * from "./TeamFileReviewsByDay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0789d8",
  null
  
)

export default component.exports